import { nanoid } from 'nanoid';
import { POLL_FILE as QuestionType } from '../../../../../poll';
import { Unboxed } from '../../../../schemaUtils';
import { config } from './FilePoll.config';

type AnswerType = Unboxed<QuestionType['data']['answers']>;

export function generateQuestion(_answers: AnswerType[], overrides: Partial<QuestionType['data']> = {}): QuestionType {
  return {
    id: nanoid(10),
    data: {
      answers: [],
      fileType: 'IMAGE',
      logicRules: [],
      requiresAnswer: false,
      text: '',
      type: config.name,
      ...overrides,
    },
  };
}

export function generateAnswer(overrides: Partial<AnswerType> = {}): AnswerType {
  return {
    id: nanoid(10),
    isCorrect: false,
    text: '',
    ...(overrides as any),
  };
}
